import React, { useState } from 'react'
import "./Tabs.css"
import { act } from 'react-dom/test-utils';
import Nav from 'react-bootstrap/Nav'

export default function Tabs() {
  const [activeTab, setActiveTab] = useState('articles'); // State to track active tab
  const [currentCard, setCurrentCard] = useState(1);
  const handleDotClick = (e, index) => {
    e.target.click()
    if (index === 0) {
      setCurrentCard(0)
    } else {
      console.log(index);
      setCurrentCard(index)
    }

  };
  // Sample data for articles and blogs (you can replace this with your actual data)
  // const articles = [
  //   { id: 1, title: 'Evolvement and Transformation Towards Climate Resilient India', content: 'To rebook at the challlenges posed by climate change, Global Warming, and as a result of these the extreme turns athat of late weather has ofthen been taking, India Cnetre fo Policy Research and Development (ICPRD) held a day-long exchange of views among experts and thought leaders....', Author: "ADMIN", date: "April 15, 2023 ",url: "/" },
  //   { id: 2, title: 'Evolvement and Transformation Towards Climate Resilient India', content: 'To rebook at the challlenges posed by climate change, Global Warming, and as a result of these the extreme turns athat of late weather has ofthen been taking, India Cnetre fo Policy Research and Development (ICPRD) held a day-long exchange of views among experts and thought leaders....', Author: "ADMIN", date: "April 15, 2023 ",url: "/" },
  //   { id: 3, title: 'Evolvement and Transformation Towards Climate Resilient India', content: 'To rebook at the challlenges posed by climate change, Global Warming, and as a result of these the extreme turns athat of late weather has ofthen been taking, India Cnetre fo Policy Research and Development (ICPRD) held a day-long exchange of views among experts and thought leaders....', Author: "ADMIN", date: "April 15, 2023 ",url: "/" },
  //   // Add more articles here
  // ];

  const blogs = [
    { id: 1, title: 'Climate Change Policy', content: 'Back in 2014, the Union Ministry of Environment and Forests changed its name to the Union Ministry of Environment, Forests, and Climate Change. The ministrys portfolio did include climate change earlier as well, but the focus had been primarily on international negotiations. The change in nomenclature clearly indicated....', Author: "ADMIN", date: "October 04, 2022 ",url: "/blog/indias-climate-change-policy" },
    { id: 2, title: 'Climate change & Corporate-Scape', content: 'As people around the world have become aware of the ramifications of the climate crisis, the entities with the most power and scope to mitigate it—The corporations—have begun to tremble. Corporations manufacture nearly everything we buy, use, and discard...', Author: "ADMIN", date: "October 05, 2022 ",url: "/blog/changing-corporate-scape-changing-climate" },
    { id: 3, title: 'Legalities around Climate Change', content: 'India is one of the countries vulnerable to climate change. Agriculture and other climate-sensitive industries employ roughly half of Indias population. About 12% of India is prone to flooding, while 16% is prone to drought. India is now the worlds third largest emitter of...', Author: "ADMIN", date: "October 05, 2022 ",url: "/blog/legalities-around-climate-change" }
    // Add more blogs here
  ];

  // Function to toggle between "Articles" and "Blogs" tabs
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const renderDots = (activeTab) => {
    if (activeTab === "blogs") {
      return blogs.map((_, index) => (
        <label for={`t${index}`} id={`tab${index}`} key={index}
                
                onClick={(e) => handleDotClick(e,index)} className={`carousel-dot ${index === currentCard ? 'active-dot' : ''}`}><span
                
            ></span></label>
      ));
    } else {
      return blogs.map((_, index) => (
        <label for={`t${index}`} id={`tab${index}`} key={index}
                
                onClick={(e) => handleDotClick(e,index)} className={`carousel-dot ${index === currentCard ? 'active-dot' : ''}`}><span
                
            ></span></label>
      ));
    }

  };

  return (
    <div className="tab-component">
      <div className="tabs">
      <button
          className={`tab-button ${activeTab === 'blogs' ? '' : ''}`}
          onClick={() => handleTabClick('blogs')}
        >
          <h1 className='aticalesm articlss' >Blogs</h1>
          <Nav.Link href="/blog"><h1 className='aticalesm articls' >View All</h1></Nav.Link>
        </button>
{/*         
        <button
          className={`tab-button ${activeTab === 'articles' ? 'active' : ''}`}
          onClick={() => handleTabClick('articles')}
        >
          <h1 className='aticalesm'>Articles</h1>
        </button> */}
   
      </div>
      <div className="content-wrapper">
      <input type="radio" name="sliderTab" class="d-none" id="t0" />
                <input type="radio" name="sliderTab" class="d-none" id="t1" checked />
                <input type="radio" name="sliderTab" class="d-none" id="t2" />
        {activeTab === 'blogs' ? (
          <div className="card-list" >
            {blogs.map((article,index) => (
              <div className="card" key={article.id} id={`tabCard${index}`}>
                <h3>{article.title}</h3>
                <hr className='card-hr' />
                <p>{article.content}</p>
                <footer className='article-card-footer'>
                  <div>
                    <h4>{article.Author}</h4>
                    <small>{article.date}</small>
                  </div>
                  <a href={article.url}>Read More</a>
                </footer>
              </div>
            ))}
          </div>
        ) : (
          <div className="card-list">
            {blogs.map((blog,index) => (
              <div className="card" key={blog.id} id={`tabCard${index}`}>
                <h3>{blog.title}</h3>
                <hr className='card-hr' />
                <p>{blog.content}</p>

                <footer className='article-card-footer'>
                  <div>
                    {/* <h4>{blog.Author}</h4> */}
                    <small>{blog.date}</small>
                  </div>
                  <a href={blog.url}>Read More</a>
                </footer>
              </div>

            ))}
          </div>
        )}
      </div>

      <div className="carousel-dots domrt">{renderDots(activeTab)}
        <hr className="slider-hr" /></div>
    </div>
  );
}
